import InfoTwoTone from '@mui/icons-material/InfoTwoTone';
import WarningAmber from '@mui/icons-material/WarningAmber';
import type { SxProps } from '@mui/material/styles';
import { useMemo } from 'react';

import { CampaignType } from 'api';
import { mapCampaignTypeToColor } from 'domain/campaign/CampaignType';
import { Sxable } from 'library/types';

interface CampaignWarningProps extends Sxable {
	campaignType: CampaignType;
}

const defaultIconSx: SxProps = {
	fontSize: 'big',
	background: 'white',
	borderRadius: '50%',
};

export const CampaignWarning = ({
	campaignType,
	sx = {},
}: CampaignWarningProps): React.JSX.Element => {
	const Icon = useMemo(() => {
		const props = {
			color: mapCampaignTypeToColor(campaignType),
			sx: { ...defaultIconSx, ...sx },
		};
		const IconType =
			campaignType === 'Service' ? InfoTwoTone : WarningAmber;

		return <IconType {...props} />;
	}, [campaignType, sx]);

	return Icon;
};
